import React, { useState } from "react";

function RegFeeStatusModal({ title, onClose, regFeeModalData }) {
  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content shadow rounded-4">
            <div className="modal-header">
              <h5 className="mb-0">{title}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body fs-9">
              <div className="mb-2 d-flex justify-content-between">
                <strong>Admission No:</strong>
                <span>{regFeeModalData.studentFirstRegistartionCode}</span>
              </div>
              <div className="mb-2 d-flex justify-content-between">
                <strong>Pupil Name:</strong>
                <div>{regFeeModalData.studentName}</div>
              </div>
              <div className="mb-2 d-flex justify-content-between">
                <strong>Paid:</strong>
                <div>{regFeeModalData.isPaid ? "Yes" : "No"}</div>
              </div>
              <div className="mb-2 d-flex justify-content-between">
                <strong>Challan No:</strong>
                <div>{regFeeModalData.voucherNo}</div>
              </div>
              <div className="mb-2 d-flex justify-content-between">
                <strong>Bank:</strong>
                <div>{regFeeModalData.bankName}</div>
              </div>
              <div className="mb-2 d-flex justify-content-between">
                <strong>Account No:</strong>
                <div>{regFeeModalData.accountNo}</div>
              </div>
              <div className="mb-2 d-flex justify-content-between">
                <strong>Receipt No:</strong>
                <div>{regFeeModalData.receiptNo}</div>
              </div>

              <div className="text-center mt-4">
                <button
                  className="btn btn-primary btn-sm w-100 rounded-pill"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default RegFeeStatusModal;
